var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 73,
    viewBox: "0 0 86 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 71.6001H74.9",
    stroke: "#989898",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47.8999V61.4999C48 66.9999 52.5 71.4999 58 71.4999H64.8",
    stroke: "#989898",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47.8999V61.4999C38 66.9999 33.5 71.4999 28 71.4999H21.2",
    stroke: "#989898",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 49.2998C0 52.5998 2.7 55.2998 6 55.2998H80C83.3 55.2998 86 52.5998 86 49.2998V46.2998H0V49.2998Z",
    fill: "#989898"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 6.2998C86 2.9998 83.3 0.299805 80 0.299805H6C2.7 0.299805 0 2.9998 0 6.2998V43.2998H86V6.2998Z",
    fill: "#82AA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9 9.1001H10.8V19.6001H74.9V9.1001Z",
    stroke: "white",
    strokeWidth: 1.8972,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1 25.8003H10.2V43.4003H27.1V25.8003Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 25.8003H34.6V43.4003H51.5V25.8003Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9 25.8003H59V43.4003H75.9V25.8003Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.400cd833351ff2d923e2bbba647c6f1c.svg";
export { ForwardRef as ReactComponent };